/**
 * Dettaglio dietro un numero della Dashboard: elenco delle righe che compongono quel numero, apribile in un pannello
 * ed esportabile in Excel. Ogni widget descrive il suo dettaglio con una DetailRequest e la apre con openDetail().
 */
export type DetailCell = string | number | null;

export interface DetailColumn {
  key: string;
  label: string;
  /** Come si mostra e si esporta: euro, giorno, giorno e ora, numero, etichetta (chip). Senza indicazione e' testo. */
  kind?: 'text' | 'money' | 'date' | 'datetime' | 'number' | 'tag';
}

export interface DetailRow {
  id: string;
  cells: Record<string, DetailCell>;
  /** Se presente, il clic sulla riga apre la scheda del lead / cliente. */
  clientId?: string | null;
  /** Se presente, il clic sulla riga apre l'offerta. */
  dealId?: string | null;
}

export interface DetailResult {
  rows: DetailRow[];
  /** Quante righe esistono in tutto (puo' superare quelle caricate). */
  total: number;
  /** Frase in piu' per il sottotitolo (es. "su 47 lead"). */
  summary?: string | undefined;
  /** Riga di totale da mostrare in fondo (es. somma degli importi). */
  footer?: Record<string, DetailCell> | undefined;
}

export interface DetailRequest {
  /** Identifica la richiesta (cambia = ricarica). */
  key: string;
  title: string;
  subtitle?: string;
  columns: DetailColumn[];
  load: () => Promise<DetailResult>;
  /** Nome del file Excel, senza estensione. */
  fileName: string;
}

/** Quante righe al massimo si caricano nel pannello e nel file Excel. */
export const DETAIL_MAX_ROWS = 5000;
